import { useEffect, useState } from "react";
import axios from "axios";
import { CalendarCheck, Play, Loader2 } from "lucide-react";

const REASON_COLORS = {
  due_task:      { bg: "#FEE2E2", fg: "#B91C1C" },
  committed:     { bg: "#FEF3C7", fg: "#92400E" },
  decay:         { bg: "#FFEDD5", fg: "#C2410C" },
  soft_reminder: { bg: "#E0E7FF", fg: "#3730A3" },
  hot_topup:     { bg: "#DCFCE7", fg: "#166534" },
};

export const PersonalReasonTag = ({ reasonKey, label, testid }) => {
  if (!reasonKey || !label) return null;
  const c = REASON_COLORS[reasonKey] || { bg: "#F1F5F9", fg: "#475569" };
  return (
    <span data-testid={testid} title={label} style={{
      display: "inline-block", maxWidth: "100%", padding: "1px 8px", borderRadius: 999, fontSize: 10, fontWeight: 600,
      background: c.bg, color: c.fg, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", verticalAlign: "middle",
    }}>{label}</span>
  );
};

// Virtual, always-first "Personal Campaign" entry in the dialer campaign list.
export const PersonalCampaignEntry = ({ apiBase, authToken, reloadKey, onStart }) => {
  const [count, setCount] = useState(null);

  useEffect(() => {
    let cancelled = false;
    setCount(null);
    axios.get(`${apiBase}/api/dialer/personal-campaign/live`, { headers: { Authorization: `Bearer ${authToken}` }, timeout: 20000 })
      .then(r => { if (!cancelled) setCount(Number(r.data?.count || 0)); })
      .catch(() => { if (!cancelled) setCount(0); });
    return () => { cancelled = true; };
  }, [apiBase, authToken, reloadKey]);

  const loading = count === null;
  const empty = count === 0;
  const disabled = loading || empty;
  return (
    <button
      type="button"
      data-testid="personal-campaign-entry"
      disabled={disabled}
      onClick={() => !disabled && onStart?.()}
      className="card"
      style={{
        display: "flex", alignItems: "center", gap: 12, padding: "14px 16px", width: "100%", textAlign: "left",
        fontFamily: "var(--font)", border: "1px solid #BFDBFE", borderLeft: "4px solid #2563eb",
        background: empty ? "#F8FAFC" : "#F5F9FF", cursor: disabled ? "default" : "pointer",
        opacity: empty ? 0.65 : 1, transition: "background-color 150ms ease, opacity 150ms ease",
      }}
    >
      <CalendarCheck style={{ width: 16, height: 16, color: "#2563eb", flexShrink: 0 }} />
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <span data-testid="personal-campaign-entry-title" style={{ fontSize: 13, fontWeight: 600, color: "#1B365D" }}>
            Personal Campaign ({loading ? "…" : count})
          </span>
          <span style={{ padding: "1px 7px", borderRadius: 10, fontSize: 9, fontWeight: 700, letterSpacing: 0.3, textTransform: "uppercase", background: "#DBEAFE", color: "#1D4ED8" }}>Today</span>
        </div>
        <div data-testid="personal-campaign-entry-subtitle" style={{ fontSize: 11, color: "#64748b", marginTop: 3 }}>
          {loading ? "Building today's queue…" : empty ? "Nothing due today" : "Due tasks, callbacks, decay warnings, soft-lock reminders and hot leads"}
        </div>
      </div>
      {loading ? (
        <Loader2 className="spin" style={{ width: 14, height: 14, color: "#94a3b8" }} />
      ) : !empty && (
        <span data-testid="personal-campaign-start" style={{ background: "#2563eb", color: "#fff", borderRadius: 8, padding: "5px 14px", fontSize: 12, fontWeight: 500, display: "inline-flex", alignItems: "center", gap: 5 }}>
          <Play style={{ width: 11, height: 11 }} /> Start calling
        </span>
      )}
    </button>
  );
};
